import { meta } from '@/helpers/constants/router';
import { Step } from '@/helpers/entities/enums/v2/Step';
// lazy load components
// https://router.vuejs.org/guide/advanced/lazy-loading.html
const Wrapper = () => import('@/views/Wrapper.vue');
const BundleSelection = () => import('@/views/v2/DiyBundleSelection.vue');
export default [
    {
        path: '/diy',
        component: Wrapper,
        meta,
        children: [
            {
                path: ':appUuid/step-redirecter',
                name: 'step-redirecter',
                component: () => import('@/views/v2/diy/StepRedirecter.vue'),
                props: true,
                meta: {
                    ...meta,
                },
            },
            {
                path: 'choose-service-bundle',
                name: 'choose-service-bundle',
                component: BundleSelection,
                meta: {
                    ...meta,
                    title: 'Choose the right option for your business',
                    step: Step.One,
                },
            },
            {
                path: ':serviceBundleUuid/apps/:appUuid',
                component: Wrapper,
                meta: {
                    ...meta,
                },
                children: [
                    // {
                    //   path: 'choose-your-plan',
                    //   name: 'choose-your-plan',
                    //   component: () => import('@/views/v2/ChoosePlans.vue'),
                    //   props: true,
                    //   meta: {
                    //     ...meta,
                    //     title: 'Choose your plan',
                    //     step: Step.Two,
                    //   },
                    // },
                    {
                        path: 'connect-your-facebook',
                        name: 'connect-your-facebook',
                        component: () => import('@/views/v2/PageActivation.vue'),
                        props: true,
                        meta: {
                            ...meta,
                            title: 'Connect your Facebook Page.',
                            subtitle: 'Connect your selected Facebook Page to create an In-App Store.',
                            step: Step.Two,
                        },
                    },
                    {
                        path: 'pages/:pageUuid',
                        component: Wrapper,
                        props: true,
                        meta: {
                            ...meta,
                        },
                        children: [
                            {
                                path: 'customize-mini-app',
                                name: 'customize-mini-app',
                                component: () => import('@/views/v2/DiyWrapper.vue'),
                                props: true,
                                meta: {
                                    ...meta,
                                    title: 'Setup In-App Store',
                                    subtitle: 'Tailor your store to your preference and fill out the necessary details here.',
                                    step: Step.Three,
                                },
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
